import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Users, Rocket, PenTool, MonitorPlay, Trophy } from "lucide-react";

const Process: React.FC = () => {
	const steps = [
		{
			id: "team",
			title: "チーム結成",
			description: "3-4名でチームを組みます",
			icon: Users,
			details: [
				"個人での参加も可能です",
				"当日のチーム結成もサポート",
				"スキル分布を考慮したチーム編成",
			],
		},
		{
			id: "ideation",
			title: "アイデア出し",
			description: "チームでアイデアを練ります",
			icon: Rocket,
			details: [
				"テーマに沿ったアイデア出し",
				"メンターによるアドバイス",
				"実現可能性の検討",
			],
		},
		{
			id: "design",
			title: "設計・デザイン",
			description: "解決策の具体化",
			icon: PenTool,
			details: ["プロトタイプの作成", "ユーザー体験の設計", "技術選定"],
		},
		{
			id: "development",
			title: "開発",
			description: "アイデアを形にします",
			icon: MonitorPlay,
			details: ["チーム開発", "技術的サポート", "進捗管理"],
		},
		{
			id: "presentation",
			title: "プレゼンテーション",
			description: "成果を発表します",
			icon: Trophy,
			details: ["デモンストレーション", "審査員からのフィードバック", "表彰式"],
		},
	];

	return (
		<section className="py-16">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-4 text-center">開催の流れ</h2>
				<p className="text-gray-600 text-center mb-12">
					2日間で以下のプロセスを進めていきます
				</p>
				<div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6">
					{steps.map((step) => (
						<Card key={step.id}>
							<CardHeader>
								<div className="flex items-center gap-3">
									<step.icon className="w-6 h-6 text-purple-600" />
									<CardTitle>{step.title}</CardTitle>
								</div>
								<CardDescription>{step.description}</CardDescription>
							</CardHeader>
							<CardContent>
								<ul className="list-disc list-inside space-y-2 text-sm text-gray-600">
									{step.details.map((detail) => (
										<li key={detail}>{detail}</li>
									))}
								</ul>
							</CardContent>
						</Card>
					))}
				</div>
			</div>
		</section>
	);
};

export default Process;
